function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#00A19A;}\n\t.st1{fill:#EDEDED;}\n\t.st2{fill:#E94E1B;}\n\t.st3{fill:#F39200;}\n\t.st4{fill:#FFFFFF;}\n"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_1",
  transform: "matrix(1, 0, 0, 1, -100.532959, -206)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 292.25,
  cy: 394.75,
  r: 188.75
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "219,250.8 217.87,243.28 211.04,239.94 217.84,236.55 218.9,229.01 224.24,234.44 231.73,233.12  228.22,239.87 231.79,246.58 224.28,245.33 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "308.02,314.95 315.61,299.56 307.25,284.59 324.23,287.06 335.89,274.47 338.78,291.38 354.35,298.58  339.17,306.56 337.13,323.6 324.85,311.62 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "250.42,310.58 251.73,308 250.34,305.45 253.2,305.9 255.19,303.79 255.65,306.65 258.27,307.9  255.69,309.22 255.32,312.09 253.27,310.05 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "221.41,292.25 207.28,291.47 198.63,302.67 195.01,288.99 181.69,284.22 193.58,276.55 194,262.4  204.97,271.34 218.55,267.37 213.44,280.56 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "294.05,248.18 294.39,243.49 290.72,240.55 295.29,239.42 296.95,235.02 299.43,239.02 304.13,239.24  301.1,242.83 302.34,247.37 297.98,245.6 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "319.36,528.33 322.37,522.64 319.4,516.94 325.73,518.04 330.24,513.45 331.15,519.82 336.91,522.68  331.13,525.51 330.19,531.88 325.71,527.26 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "272.24,499.09 270.19,490.08 261.61,486.66 269.55,481.93 270.15,472.71 277.1,478.8 286.05,476.52  282.41,485.01 287.34,492.83 278.14,491.99 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "278.78,562.8 278.94,556.58 273.91,552.92 279.88,551.15 281.8,545.24 285.33,550.36 291.55,550.37  287.76,555.3 289.68,561.22 283.82,559.15 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "307.25,398.73 309.17,391.64 304.42,386.04 311.75,385.68 315.61,379.43 318.22,386.29 325.35,388.03  319.64,392.63 320.19,399.95 314.04,395.94 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "277.47,342.89 278.3,332.78 270.43,326.36 280.31,324.02 283.98,314.56 289.25,323.23 299.39,323.79  292.77,331.49 295.37,341.3 286,337.39 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "229.91,351.16 229.04,345.47 223.85,342.96 229,340.37 229.78,334.66 233.83,338.75 239.51,337.73  236.87,342.85 239.59,347.93 233.9,347 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "391.8,265.64 391.82,261.75 388.63,259.53 392.33,258.35 393.46,254.62 395.73,257.78 399.61,257.7  397.31,260.84 398.59,264.51 394.9,263.29 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "345.11,239.91 345.42,231.69 338.83,226.77 346.74,224.52 349.38,216.73 353.96,223.57 362.18,223.67  357.1,230.14 359.55,237.99 351.82,235.15 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "379.58,299.03 380.44,295.53 378.04,292.84 381.63,292.57 383.45,289.45 384.82,292.79 388.34,293.56  385.59,295.89 385.95,299.48 382.88,297.58 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "356.45,342.89 356.85,339.77 354.51,337.67 357.6,337.09 358.87,334.22 360.38,336.97 363.51,337.29  361.35,339.58 362.01,342.65 359.17,341.31 \t"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_2",
  transform: "matrix(1, 0, 0, 1, -100.532959, -206)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M209.5,564.93c-13.99-6.83-35.68-19.41-56.19-41.36c-7.57-8.1-63.91-70.44-50.81-156.57 c6.68-43.93,28.53-75,42.22-91.22c10.3,4.75,34.95,17.78,53.28,46.22c0.55,0.85,0.95,1.53,1.29,2.09 c14.92,24.54,21.04,48.24,24.71,66.91c3.89,19.77,10.43,61.32,8,124c-0.94,24.41-2.95,44.36-4.51,57.45 C221.49,569.94,215.5,567.43,209.5,564.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M374.03,564.93c13.99-6.83,35.68-19.41,56.19-41.36c7.57-8.1,63.91-70.44,50.81-156.57 c-6.68-43.93-28.53-75-42.22-91.22c-10.3,4.75-34.95,17.78-53.28,46.22c-0.55,0.85-0.95,1.53-1.29,2.09 c-14.92,24.54-21.04,48.24-24.71,66.91c-3.89,19.77-10.43,61.32-8,124c0.94,24.41,2.95,44.36,4.51,57.45 C362.04,569.94,368.04,567.43,374.03,564.93z"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_3",
  transform: "matrix(1, 0, 0, 1, -100.532959, -206)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M143.72,275.78c-7.84,9.88-16.78,22.92-24.72,39.22c-9.65,19.8-14.72,37.99-17.5,52 c7.04-6.67,14.07-13.33,21.11-20L134,410l5-67.11L165.32,361c0,0-22.68-87,0-36S187,409,188,376s-24.24-63.17,1-33 s25.24,30.17,25.24,30.17c-0.31-6.91-1.3-16.35-4.24-27.17c-1.73-6.37-4.66-16.87-11.91-28.84c-3.39-5.59-10.07-16.38-22.91-26.18 C163.27,281.89,151.45,277.76,143.72,275.78z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M439.78,275.78c7.84,9.88,16.78,22.92,24.72,39.22c9.65,19.8,14.72,37.99,17.5,52 c-7.04-6.67-14.07-13.33-21.11-20l-11.39,63l-5-67.11L418.18,361c0,0,22.68-87,0-36s-21.68,84-22.68,51s24.24-63.17-1-33 s-25.24,30.17-25.24,30.17c0.12-6.63,0.94-16.2,4.24-27.17c4.69-15.6,11.99-25.99,16.36-32.11c5.02-7.02,12.38-17.14,25.53-26.18 C424.76,281.26,433.61,277.74,439.78,275.78z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M179.76,319.12"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_4",
  transform: "matrix(1, 0, 0, 1, -100.532959, -206)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M209.5,565.93c-6.69-7.36-14.8-17.91-21.5-31.93c-11.07-23.13-12.92-44.4-13-57c0.88-13.12,3.91-32.34,14-53 c20.14-41.25,54.86-60.54,68-67c5.76,9.27,19.74,34.51,18,69c-1.39,27.55-12.13,47.61-18,57c-4.57,3.63-13.81,12-19,26 c-7.76,20.93-0.89,39.36,1,44c1.87,8.48,3.74,16.96,5.61,25.43L209.5,565.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M376.65,565.93c6.69-7.36,14.8-17.91,21.5-31.93c11.07-23.13,12.92-44.4,13-57c-0.88-13.12-3.91-32.34-14-53 c-20.14-41.25-54.86-60.54-68-67c-5.76,9.27-19.74,34.51-18,69c1.39,27.55,12.13,47.61,18,57c4.57,3.63,13.81,12,19,26 c7.76,20.93,0.89,39.36-1,44c-1.87,8.48-3.74,16.96-5.61,25.43L376.65,565.93z"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_5",
  transform: "matrix(1, 0, 0, 1, -100.532959, -206)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M198.56,406.43c2.31-3.43,4.97-7.05,8.03-10.77c4.07-4.96,8.13-9.22,11.94-12.85 c5.91-4.84,11.81-9.67,17.72-14.51c6.92-4.1,13.84-8.2,20.75-12.3c3.69,4.66,8.16,11.52,11.16,20.62c1.25,3.78,2.04,7.33,2.53,10.5 c2.19,7.72,5.91,18.44,4.46,31.1c-3.25,28.28-3.25,28.28-3.25,28.28l-6.36-19.55c0,0-4.65,34.62-7.27,5.53 c-2.62-29.09-2.62-29.09-2.62-29.09l-9.89,12.22l-4.07-13.09l-31.13,37.53c0,0,10.18-21.08,1.45-15.92 c-8.73,5.16-16,28.43-8.73,5.16c7.27-23.27,7.27-23.27,7.27-23.27L198.56,406.43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M236.25,368.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M387.92,405.79c-2.31-3.43-4.97-7.05-8.03-10.77c-4.07-4.96-8.13-9.22-11.94-12.85 c-5.91-4.84-11.81-9.67-17.72-14.51c-6.92-4.1-13.84-8.2-20.75-12.3c-3.69,4.66-8.16,11.52-11.16,20.62 c-1.25,3.78-2.04,7.33-2.53,10.5c-2.1,8.18-4.21,19.12-4.46,31.1c-0.15,7.42,0.45,12.93,0.62,14.37 c0.64,5.53,1.66,10.24,2.63,13.91c2.12-6.52,4.24-13.03,6.36-19.55c0,0,4.65,34.62,7.27,5.53c2.62-29.09,2.62-29.09,2.62-29.09 l9.89,12.22l4.07-13.09l31.13,37.53c0,0-10.18-21.08-1.45-15.92c8.73,5.16,16,28.43,8.73,5.16c-7.27-23.27-7.27-23.27-7.27-23.27 L387.92,405.79z"
}));
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 382.464 377.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25aaef964a6d77fd1d8ad9c43e91e54a.svg";
export { ForwardRef as ReactComponent };